export function QueueRefillPanel({ stage, status, reviewedCount, acceptedCount }: {
  stage?: string;
  status?: string;
  reviewedCount: number;
  acceptedCount: number;
}) {
  const detail = status === 'failed_retryable'
    ? 'A temporary generation issue is being retried automatically.'
    : status === 'queued' || status === 'paused_buffer_full'
      ? 'The next batch is queued for generation.'
      : stage === 'image_occlusion' || stage === 'image_occlusion_due' || stage === 'media_pending'
        ? 'Processing lecture images and building image occlusion cards.'
        : stage === 'planning'
          ? 'Selecting more facts from your lecture for the next cards.'
          : 'Turning the next lecture facts into review-ready cards.';

  return (
    <div className="flex min-h-[300px] flex-col items-center justify-center rounded-3xl border border-border bg-card px-6 py-10 text-center sm:min-h-[360px]" role="status" aria-live="polite">
      <span aria-hidden="true" className="mb-5 h-8 w-8 rounded-full border-2 border-primary/25 border-t-primary motion-safe:animate-spin" />
      <p className="text-xs font-semibold uppercase tracking-widest text-primary">You’re caught up</p>
      <h2 className="mt-2 font-serif text-2xl font-semibold text-foreground">Preparing your next batch…</h2>
      <p className="mt-3 max-w-lg text-sm leading-6 text-muted">{detail} New cards will appear here automatically as they’re ready.</p>
      <p className="mt-5 text-sm font-semibold text-foreground">{reviewedCount} reviewed · {acceptedCount} kept</p>
      <p className="mt-2 max-w-lg text-xs leading-5 text-muted">Your decisions are saved.</p>
    </div>
  );
}
